/** Shared validator helpers: turn order and the AP / per-action-cap budget. */
import { type ActionType, actionCap } from "../data/constants";
import {
  invalid,
  type PlayerId,
  type ValidationResult,
  valid,
} from "../types/common";
import type { AugmentedWarState } from "../types/game-state";

export function validateTurn(
  state: AugmentedWarState,
  playerId: PlayerId,
): ValidationResult {
  if (state.phase === "GAME_END") {
    return invalid("Game is already over");
  }
  if (state.currentPlayerId !== playerId) {
    return invalid("It is not this player's turn", {
      currentPlayerId: state.currentPlayerId,
      playerId,
    });
  }
  return valid;
}

export function validateActionBudget(
  state: AugmentedWarState,
  action: ActionType,
): ValidationResult {
  if (state.apRemaining < 1) {
    return invalid("No action points remaining");
  }
  const faction = state.players[state.currentPlayerId].faction;
  const cap = actionCap(faction, action);
  if (state.actionsUsed[action] >= cap) {
    return invalid(`Per-turn cap reached for ${action}`, { cap });
  }
  return valid;
}
